import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

export default makeStyles((theme: Theme) => ({
    headingContainer: {
        margin: '25px 0',
        borderBottom: `1px solid ${theme.colors.dark.dark4}`,
    },
    subHeadingContaner: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    heading: {
        color: theme.colors.white,
        fontSize: 16,
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        margin: 0,
    },
    subHeading: {
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        color: theme.colors.white,
        fontSize: 11,
        opacity: 0.5,
    },
    hyperlink: {
        fontFamily: theme.typographyPresets.fonts.monserrat.light,
        color: theme.colors.white,
        fontSize: 11,
        opacity: 0.9,
        textDecoration: 'underline',

        '&:hover': {
            color: theme.colors.white,
            textDecoration: 'underline',
        },
    },
}))
